import axios from "axios";
import { url } from "../../../App";

export const getPanLogs = async ({
  page,
  rowsPerPage,
  order,
  orderBy,
  filters,
  type,
}) => {
  const params = {
    type,
    page,
    rowsPerPage,
    order,
    orderBy,
    ...filters,
  };

  try {
    const { data } = await axios.get(`${url}/api-logs/filter`, {
      params: {
        params,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const singleFilter = async ({ type, filter, filterType }) => {
  try {
    const { data } = await axios.get(`${url}/api-logs/single-filter`, {
      params: {
        filter,
        type,
        filterType,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
  }
};
